import { useTranslation } from 'react-i18next';
import { NavLink as RouterLink } from 'react-router-dom';
import { StyledNavItem, StyledNavItemIcon } from '../../../components/nav-section/styles';
import { navMobilebar } from '../leftNavigation/config';
const FooterSection = () => {
  const { t: translate } = useTranslation();
  return navMobilebar(translate).map((nav) => {
    return (
      <StyledNavItem
        component={RouterLink}
        to={nav.path}
        sx={{
          '&.active': {
            color: 'primary.main',
            bgcolor: 'action.selected',
            fontWeight: 'fontWeightBold',
          },
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <StyledNavItemIcon component={RouterLink} to={nav.path}>
          {nav.icon && nav.icon}
        </StyledNavItemIcon>
      </StyledNavItem>
    );
  });
};
export default FooterSection;
